import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';

// TODO: Add a contact form as alternative to WhatsApp
// TODO: Consider adding a map showing service area

const ContactPage = () => {
  console.log('[ContactPage] Rendering contact page');

  return (
    <>
      <Helmet>
        <title>Contact Us | DD Construction - Get a Free Quote</title>
        <meta name="description" content="Get in touch with DD Construction for a free quote on your next building or renovation project. Professional residential construction services across South Africa." />
        <meta property="og:title" content="Contact Us | DD Construction - Get a Free Quote" />
        <meta property="og:description" content="Get in touch with DD Construction for a free quote on your next building or renovation project." />
        <meta property="og:url" content="https://www.ddconstruction.co.za/contact" />
        <link rel="canonical" href="https://www.ddconstruction.co.za/contact" />
      </Helmet>

      {/* Page Header */}
      <section className="contact-hero">
        <Container>
          <Row className="justify-content-center">
            <Col md={8}>
              <h1>Get in Touch</h1>
              <p className="lead">
                Ready to start your construction project? We'd love to hear from
                you. Reach out via WhatsApp for a quick response.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* QR Code Section */}
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col md={8} lg={6}>
            <div className="qr-card">
              <a href="https://wa.me/+27824405441?text=Hi Mike!">
                <Image
                  src="/assets/qr_code.png"
                  alt="Scan this QR code to contact us via WhatsApp"
                  style={{ maxWidth: '280px', cursor: 'pointer' }}
                  fluid
                />
              </a>
              <p className="qr-label">
                <i className="bi bi-qr-code-scan me-2"></i>
                Scan or click the QR code to chat with us on WhatsApp
              </p>
            </div>
          </Col>
        </Row>

        {/* Contact Info */}
        <Row className="justify-content-center mt-5">
          <Col md={8}>
            <div className="text-center">
              <h3 className="mb-4">Or reach us directly</h3>
              <a
                href="https://wa.me/+27824405441?text=Hi Mike!"
                className="btn btn-outline-primary btn-lg"
              >
                <i className="bi bi-whatsapp me-2"></i>
                Chat on WhatsApp
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ContactPage;
